export const REACTION_EMOJIS = ['👍', '👏', '🔥', '❤️', '⚡', '🏆'];
